import { Col, Row } from "reactstrap";

const Estructura = () => {
  return (
    <Row className="p-2">
      <Col xs={12} sm={6} className="px-5 mt-5">
        <p className="font-weight-bold">
          Sistema de anclaje al suelo por tornillos de acero libre de hormigón
        </p>
        <ul className="mt-3">
          <li>
            Los tornillos de anclaje diseñados y fabricados por Avantsolar,
            tienen un ala mucho mas ancha y rígida que la utilizada por otros
            fabricantes, esta característica hace que la cimentación sea mucho
            mas estable y resistente.
          </li>
          <li>
            El sistema de anclaje no utiliza hormigón, lo que hace que sea
            completamente desmontable, facilitando los requerimientos
            medioambientales y de desmantelamiento.
          </li>
        </ul>
        <hr />
        <p className="font-weight-bold">
          Menos obra civil, más rapidez en montaje
        </p>
        <ul className="mt-3">
          <li>
            Todo el cableado puede ir por la estructura del seguidor, de esta
            manera reducimos el numero de zanjas necesarias.
          </li>
        </ul>
      </Col>

      <Col xs={12} sm={6} className="px-5 mt-5">
        <p className="font-weight-bold">Resistencia al viento sobresaliente</p>
        <ul className="mt-3">
          <li>
            El seguidor presenta una alta resistencia al viento, esta
            resistencia está determinada por la disposición de los módulos. Los
            módulos se agrupan presentando una superficie máxima de hasta 12m2
            por grupo, con grandes distancias entre los diferentes grupos de
            módulos, lo que resulta en presiones de viento reducidas sobre el
            plano de los módulos.{" "}
          </li>
          <li>
            Para garantizar el mejor anclaje posible de los módulos, la fijación
            de los mismos a la estructura se realiza por 4 puntos, en lugar de
            la fijación estándar de dos anclajes.
          </li>
        </ul>
      </Col>
    </Row>
  );
};

export default Estructura;
